// Consultation mode must be enforced from permissions, not from mutable toggle
// state — a locked user (no fullConfigurator group) stays in consultation view
// even if something sets the toggle state to off (e.g., a loaded config).
export function deriveEffectiveConsultationMode(consultationMode, canToggleConsultation) {
  return consultationMode || !canToggleConsultation;
}

// Seed/reset value for the consultation toggle. Keyed on toggle rights
// (fullConfigurator), NOT on pricing access — a fullConfigurator user without
// specialPricing has the full configurator view, so starting them in
// consultation mode hid the BOM, the pricing card and the Summary PDF button
// (CONF-187). A vendor that forces consultation mode still wins.
export function deriveInitialConsultationMode(canToggleConsultation, forceConsultationMode) {
  return forceConsultationMode || !canToggleConsultation;
}
